<!-- Body -->
<div class="ui basic segment" [class.loading]="isLoading">
    <app-header
        title="{{ 'payroll.ytds.yeartodates' | translate }}"
        [menuService]="payrollModuleMenuService"
    ></app-header>

    <!-- This is shown if HR is not set up, in which case you cannot use the importer -->
    <div class="ui segment hr-not-set-up" *ngIf="!hasEmployeesOnPayroll">
        <img src="/assets/illustrations/sofa.png" />
        <p>{{ 'payroll.ytds.noEmployeesOnPayroll' | translate }}</p>
    </div>

    <!-- Only show table if there are employees -->
    <ng-container *ngIf="hasEmployeesOnPayroll">
        <!-- This is shown if benefits are not setup-->

        <ui-banner
            *ngIf="!payrollHasBeenPaid && !benefitsAreSetUp && !dismissedBenefitsWarning"
            variant="warning"
            class="margin-bottom-2"
            [closable]="true"
            (close)="dismissedBenefitsWarning = true"
        >
            {{ 'payroll.ytds.setupEmployeeBenefits' | translate }}
        </ui-banner>
        <div class="margin-bottom-4">
            <p>{{ 'payroll.ytds.finalPayPeriodInfo.line1' | translate }}</p>
            <h4>{{ 'payroll.ytds.finalPayPeriodInfo.line2Header' | translate }}</h4>
            <p [innerHTML]="'payroll.ytds.finalPayPeriodInfo.line2' | translate"></p>
            <h3>{{ 'payroll.ytds.finalPayPeriodInfo.line3Header' | translate }}</h3>
            <p>{{ 'payroll.ytds.finalPayPeriodInfo.line3' | translate }}</p>
            <h3>{{ 'payroll.ytds.finalPayPeriodInfo.line4Header' | translate }}</h3>
            <p>{{ 'payroll.ytds.finalPayPeriodInfo.line4' | translate }}</p>
            <div class="final-period-date">
                <ui-date-picker
                    label="{{ 'payroll.ytds.finalPayPeriodInfo.line5' | translate }}"
                    name="date"
                    [ngModel]="finalPayPeriod"
                    (ngModelChange)="finalPayPeriod = $event; onChangeDate($event)"
                    placeholder="{{ 'payroll.ytds.finalPayPeriodInfo.selectPayPeriodDate' | translate }}"
                    [openOnFocus]="true"
                ></ui-date-picker>
                <div
                    class="w-70 text-large font-medium text-color-primary-dark text-align-left"
                    *ngIf="finalPayPeriod != undefined"
                >
                    {{
                        'payroll.ytds.finalPayPeriodInfo.line6'
                            | translate: { startDate: formatDate(startDate), endDate: formatDate(finalPayPeriod) }
                    }}
                </div>
            </div>
            <p>{{ 'payroll.ytds.finalPayPeriodInfo.line7' | translate }}</p>
        </div>

        <div class="ui segment" *ngIf="!isLoading" [class.fullscreen]="fullscreen">
            <div class="header-container">
                <app-segment-header title="{{ 'payroll.ytds.enterPayrollYtDs' | translate }}"></app-segment-header>
                <div class="buttons">
                    <ui-button (click)="onToggleFullscreen()" type="link">
                        <mat-icon *ngIf="fullscreen" svgIcon="collapse"> </mat-icon>
                        <mat-icon *ngIf="!fullscreen" svgIcon="expand"> </mat-icon>
                        <span *ngIf="fullscreen; else exitFullScreen"
                            >{{ 'payroll.ytds.exitFullscreen' | translate }}
                        </span>
                        <ng-template #exitFullScreen>
                            <span>{{ 'payroll.ytds.openFullscreen' | translate }} </span>
                        </ng-template>
                    </ui-button>
                </div>
            </div>

            <div class="second-title padding-bottom-3">
                <ui-banner variant="bulb">
                    <div [innerHTML]="'payroll.ytds.inputYourEmployeesYtds' | translate"></div>
                </ui-banner>
            </div>

            <div class="second-title padding-bottom-3">
                <!--Employee search bar-->
                <app-search
                    (onSearch)="onSearch($event)"
                    placeholder="{{ 'payroll.ytds.search' | translate }}"
                ></app-search>

                <div class="saving-indicator" [class.error]="hasAgGridError">
                    {{
                        (hasAgGridError
                            ? 'payroll.ytds.someCellsHaveErrors'
                            : isSaving
                              ? 'payroll.ytds.saving'
                              : 'payroll.ytds.allChangesSaved'
                        ) | translate
                    }}
                </div>
            </div>

            <ng-container *ngIf="!isLoading">
                <!-- Hands on Table start here -->
                <div class="hot-container" *ngIf="!hasAgGridFeature">
                    <hot-table
                        [afterChange]="afterChange"
                        [beforeChange]="beforeChange"
                        [beforePaste]="beforePaste"
                        [cells]="cells"
                        [data]="dataset"
                        [hotId]="hotId"
                        [numericFormat]="{ pattern: '$0,0.00' }"
                        [rowHeaderWidth]="rowHeaderWidth"
                        [rowHeaders]="rowHeaders"
                        [settings]="settings"
                        [wordWrap]="false"
                    >
                        <hot-column
                            *ngFor="let column of columns"
                            [title]="column.title"
                            [data]="column.data"
                            [editor]="column.editor"
                            [type]="column.type"
                            [readOnly]="column.readOnly"
                        >
                        </hot-column>
                    </hot-table>
                </div>

                <!--Ag-grid table-->
                <ag-grid-angular
                    *ngIf="hasAgGridFeature"
                    class="ag-theme-quartz"
                    style="width: 100%; height: 55vh"
                    [suppressFieldDotNotation]="hasMultiCellPasteFeature"
                    [columnDefs]="columnDefs"
                    [rowData]="rowData"
                    [getRowId]="getRowId"
                    [enableRangeSelection]="isRangeSelectionEnabled"
                    [enableFillHandle]="isRangeSelectionEnabled"
                    [pagination]="true"
                    [paginationPageSize]="20"
                    [tooltipShowDelay]="0"
                    (gridReady)="onGridReady($event)"
                />
            </ng-container>
        </div>
    </ng-container>
</div>
